import { MotionDiv } from '@/components/element/MotionDiv';
import { useDashboardMyTaskCounts } from '@/hooks/api/2060_dashboard_my_task_counts';
import {
  defaultInvoiceTaskSearchCondition,
  defaultPaymentTaskSearchCondition,
  defaultPurchaseOrderContractTaskSearchCondition,
  defaultQuotationTaskSearchCondition,
  defaultSalesOrderContractTaskSearchCondition,
  useBackofficeSearchCondition,
} from '@/providers/BackofficeSearchConditionProvider';
import { useCurrentWorkspace } from '@/providers/WorkspaceProvider';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

export const MyTaskCounts = () => {
  const { _w_, me } = useCurrentWorkspace();
  const { data } = useDashboardMyTaskCounts({ identifier: _w_!.identifier });
  const [toMonth, setToMonth] = useState<string>('');

  const {
    setPurchaseOrderContractTaskDisplayType,
    setPurchaseOrderContractTaskSearchCondition,

    setPaymentTaskDisplayType,
    setPaymentTaskSearchCondition,

    setSalesOrderContractTaskDisplayType,
    setSalesOrderContractTaskSearchCondition,

    setQuotationTaskDisplayType,
    setQuotationTaskSearchCondition,

    setInvoiceTaskDisplayType,
    setInvoiceTaskSearchCondition,
  } = useBackofficeSearchCondition();

  useEffect(() => {
    if (data) {
      setToMonth((_) => data.target_year_month.toString().slice(-2));
    }
  }, [data]);

  const invoiceTasksClick = () => {
    setInvoiceTaskDisplayType('list');
    setInvoiceTaskSearchCondition({
      ...defaultInvoiceTaskSearchCondition,
      identifier: _w_!.identifier,
      user_ids: [me!.id],
      invoice_task_phase_ids: [1, 2, 3, 4],
    });
  };

  const paymentTasksClick = () => {
    setPaymentTaskDisplayType('list');
    setPaymentTaskSearchCondition({
      ...defaultPaymentTaskSearchCondition,
      identifier: _w_!.identifier,
      user_ids: [me!.id],
      payment_task_phase_ids: [1, 2, 4],
    });
  };

  const quotationTasksClick = () => {
    setQuotationTaskDisplayType('list');
    setQuotationTaskSearchCondition({
      ...defaultQuotationTaskSearchCondition,
      identifier: _w_!.identifier,
      user_ids: [me!.id],
      quotation_task_phase_ids: [1, 2, 3],
    });
  };

  const salesOrderContractTasksClick = () => {
    setSalesOrderContractTaskDisplayType('list');
    setSalesOrderContractTaskSearchCondition({
      ...defaultSalesOrderContractTaskSearchCondition,
      identifier: _w_!.identifier,
      user_ids: [me!.id],
      sales_order_contract_task_phase_ids: [1, 4, 5],
    });
  };

  const purchaseOrderContractTasksClick = () => {
    setPurchaseOrderContractTaskDisplayType('list');
    setPurchaseOrderContractTaskSearchCondition({
      ...defaultPurchaseOrderContractTaskSearchCondition,
      identifier: _w_!.identifier,
      user_ids: [me!.id],
      purchase_order_contract_task_phase_ids: [1, 4, 5],
    });
  };

  if (data == null) return <></>;

  return (
    <MotionDiv className="row">
      <div className="row">
        <div className="col-md-6 col-sm-12 mb-4">
          <Link
            to={`/w/${_w_!.identifier}/backoffice/invoice_tasks`}
            className="card flex-1"
            onClick={invoiceTasksClick}
          >
            <div className="card-body text-center">
              <h4 className="font-weight-bolder text-gradient text-primary">{data.invoice_task_count}</h4>
              <h6 className="text-xs mb-1">請求タスク</h6>
              <div className="text-xs text-muted">{toMonth}月分まで</div>
            </div>
          </Link>
        </div>
        <div className="col-md-6 col-sm-12 mb-4">
          <Link
            to={`/w/${_w_!.identifier}/backoffice/payment_tasks`}
            className="card flex-1"
            onClick={paymentTasksClick}
          >
            <div className="card-body text-center">
              <h4 className="font-weight-bolder text-gradient text-primary">{data.payment_task_count}</h4>
              <h6 className="text-xs mb-1">支払タスク</h6>
              <div className="text-xs text-muted">{toMonth}月分まで</div>
            </div>
          </Link>
        </div>
      </div>

      <div className="row">
        <div className="col-md-4 col-sm-12 mb-4">
          <Link
            to={`/w/${_w_!.identifier}/backoffice/quotation_tasks`}
            className="card flex-1"
            onClick={quotationTasksClick}
          >
            <div className="card-body text-center">
              <h4 className="font-weight-bolder">{data.quotation_task_count}</h4>
              <h6 className="text-xs mb-1">見積申請タスク</h6>
              <div className="text-xs text-muted">全期間</div>
            </div>
          </Link>
        </div>
        <div className="col-md-4 col-sm-12 mb-4">
          <Link
            to={`/w/${_w_!.identifier}/backoffice/sales_order_contract_tasks`}
            className="card flex-1"
            onClick={salesOrderContractTasksClick}
          >
            <div className="card-body text-center">
              <h4 className="font-weight-bolder">{data.sales_order_contract_task_count}</h4>
              <h6 className="text-xs mb-1">契約申請（売上）タスク</h6>
              <div className="text-xs text-muted">全期間</div>
            </div>
          </Link>
        </div>
        <div className="col-md-4 col-sm-12 mb-4">
          <Link
            to={`/w/${_w_!.identifier}/backoffice/purchase_order_contract_tasks`}
            className="card flex-1"
            onClick={purchaseOrderContractTasksClick}
          >
            <div className="card-body text-center">
              <h4 className="font-weight-bolder">{data.purchase_order_contract_task_count}</h4>
              <h6 className="text-xs mb-1">契約申請（費用）タスク</h6>
              <div className="text-xs text-muted">全期間</div>
            </div>
          </Link>
        </div>
      </div>
    </MotionDiv>
  );
};
